var map = {
	"./STAR_PRODUCTS_MAKE_UP.json": 6918,
	"./STAR_PRODUCTS_MAKE_UP_old.json": 1577,
	"./STAR_PRODUCTS_ar_AE.json": 5600,
	"./STAR_PRODUCTS_ar_SA.json": 5663,
	"./STAR_PRODUCTS_cs_CZ.json": 862,
	"./STAR_PRODUCTS_da_DK.json": 8666,
	"./STAR_PRODUCTS_de_AT.json": 7388,
	"./STAR_PRODUCTS_de_CH.json": 1317,
	"./STAR_PRODUCTS_de_DE.json": 300,
	"./STAR_PRODUCTS_en_AE.json": 3654,
	"./STAR_PRODUCTS_en_AU.json": 3879,
	"./STAR_PRODUCTS_en_CA.json": 9852,
	"./STAR_PRODUCTS_en_GB.json": 8521,
	"./STAR_PRODUCTS_en_HK.json": 4342,
	"./STAR_PRODUCTS_en_IN.json": 3715,
	"./STAR_PRODUCTS_en_MY.json": 7499,
	"./STAR_PRODUCTS_en_SA.json": 6459,
	"./STAR_PRODUCTS_en_SG.json": 9898,
	"./STAR_PRODUCTS_en_US.json": 325,
	"./STAR_PRODUCTS_en_ZA.json": 2957,
	"./STAR_PRODUCTS_es_ES.json": 3544,
	"./STAR_PRODUCTS_es_MX.json": 7948,
	"./STAR_PRODUCTS_fr_BE.json": 9683,
	"./STAR_PRODUCTS_fr_CA.json": 8935,
	"./STAR_PRODUCTS_fr_CH.json": 6382,
	"./STAR_PRODUCTS_fr_FR.json": 9532,
	"./STAR_PRODUCTS_id_ID.json": 5981,
	"./STAR_PRODUCTS_it_IT.json": 537,
	"./STAR_PRODUCTS_ja_JP.json": 4886,
	"./STAR_PRODUCTS_ko_KR.json": 3442,
	"./STAR_PRODUCTS_nl_BE.json": 491,
	"./STAR_PRODUCTS_nl_NL.json": 6817,
	"./STAR_PRODUCTS_pl_PL.json": 134,
	"./STAR_PRODUCTS_pt_BR.json": 1564,
	"./STAR_PRODUCTS_pt_PT.json": 8269,
	"./STAR_PRODUCTS_sv_SE.json": 2259,
	"./STAR_PRODUCTS_th_TH.json": 6537,
	"./STAR_PRODUCTS_tw_TW.json": 1587,
	"./STAR_PRODUCTS_vi_VN.json": 5523,
	"./STAR_PRODUCTS_zh_HK.json": 1604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6137;